export enum M017Theme {
    WHITE = 'white',
    LIGHT = 'light',
    DARK = 'dark'
}

export type NavActivePosition = '' | 'validPosition' | 'above' | 'below'

export type M017Props = {
  /** The heading description used in the menu */
  anchorNavigation: string[]
  activeSection?: string
  /** Optional string name for the anchor point */
  anchorName?: string
  /** Dictates the boundaries of the anchor section */
  isStart?: boolean
  /** Navigation position, can be fixed, below or above */
  navActivePos?: NavActivePosition
  /** Callback function that gets called when the component repositions */
  onAnchorEntry?: (anchorNav: string[], offsetTop: number, anchorName: string, isStart: boolean) => void | null
  /** Offset from the top of the page */
  paddingOffset: number
  /** Background color of the anchor links */
  theme: M017Theme
  type?: string
}


export type M017StyledPlaceholder = {
  activeSection: string
}

export type M017StyledCommonTheme = {
  themeMode: string
}

export type M017StyledNavButton = M017StyledCommonTheme & {
  isActive: boolean
}

export type M017StyledContainer = M017StyledCommonTheme & {
  isFixedPosition: boolean
  isFixedBelow: boolean
}